import React from "react"
import Loader from "../../../../Loader"
import BusinessTitleCard from "../../../BusinessCardTitle"
import NewBusinessIcon from "../../../../../images/business/new-business.svg"

const Summary = (props) => {
  let {
    business_name1,
    business_name2,
    business_name3,
    business_name4,
    business_nature,
    address,
    
  } = props.data.basic_business_info
  let {
    firstname,
    lastname,
    proprietor_email,
    proprietor_phone,
    proprietor_address,
    occupation,
  } = props.data.additional_info

  return (
    <div className="container summary">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <BusinessTitleCard
            title="Register a new business"
            subtitle="Officially register your business, get CAC and a tax identification number."
            icon={NewBusinessIcon}
          />

          <div className="business-suport-card my-lg-5 waitlist__form p-lg-5 p-4">
            <div className="container">
              <div className="row px-lg-5">
                <div className="business-title-step_wrapper pt-5 pb-2 border-bottom">
                  <h4 className="current-step">Application summary</h4>
                  <div className="tag">
                    <span>4 of 4</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="row position-relative">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Value Added Service</p>
                <p className="summary-description">New Business Registration</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Business Name Sample 1</p>
                <p className="summary-description">{business_name1}</p>
              </div>

              <div className="form-group col-md-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Business Name Sample 2</p>
                <p className="summary-description">{business_name2}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Business Name Sample 3</p>
                <p className="summary-description">{business_name3}</p>
              </div>

              <div className="form-group col-md-5 my-3 offset-lg-1">
                <p className="mb-1 summary-title">Business Name Sample 4</p>
                <p className="summary-description">{business_name4}</p>
              </div>
            </div>

            <div className="form-row justify-between">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Business Type</p>
                <p className="summary-description">{business_nature}</p>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-5 my-3">
                <p className="mb-1 summary-title">Business Address</p>
                <p className="summary-description">{address}</p>
              </div>
            </div>

            <>
              <div className="form-row  justify-between">
                <div className="form-group col-md-5 my-3">
                  <p className="mb-1 summary-title">Full Name</p>
                  <p className="summary-description">
                    {firstname} {lastname}
                  </p>
                </div>

                <div className="form-group col-md-5 offset-lg-1 my-3">
                  <p className="mb-1 summary-title">Email Address</p>
                  <p className="summary-description">{proprietor_email}</p>
                </div>
              </div>

              <div className="form-row justify-between">
                <div className="form-group col-md-5 my-3">
                  <p className="mb-1 summary-title">Phone Number</p>
                  <p className="summary-description">{proprietor_phone}</p>
                </div>

                <div className="form-group col-md-5 my-3 offset-lg-1">
                  <p className="mb-1 summary-title">Home Address</p>
                  <p className="summary-description">{proprietor_address}</p>
                </div>
              </div>

              <div className="form-row justify-between">
                <div className="form-group col-md-5 my-3">
                  <p className="mb-1 summary-title">Occupation</p>
                  <p className="summary-description">{occupation}</p>
                </div>

               
              </div>
            </>

            <div className="form-row  justify-between align-center my-5">
              <div className="form-group col-md-5 my-2">
                <button
                  type="submit"
                  className="btn sparkle--button__green_outline px-5 w-100 h-auto  btn-block"
                  onClick={() => props.setShowSummary(false)}
                >
                  Back
                </button>
              </div>

              <div className="form-group col-md-5 my-2">
                <button
                  className="btn sparkle--button__green px-5 w-100 h-auto btn-block"
                  onClick={props.payFee}
                  disabled={props.loadingStatus}
                >
                  {!props.loadingStatus ? (
                    `Make Payment of ₦ ${props.amount}.00`
                  ) : (
                    <>
                      <Loader width="30" color="#fff" />
                    </>
                  )}
                </button>
              </div>
            </div>

            <p className="sparkle-bright-orange text-center">
              {props.loadingStatus && "Application is in progress..."}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Summary
